// notas.util.ts — helpers de avisos/notas informativas del calendario de
// Mercado, compartidos por el calendario del cliente (MercadoCalendario) y el
// del admin (AnalisisCalendario). Round 2026-07-23.
import dayjs from "dayjs";
import { MercadoNota } from "../../services/mercado.api";

/** Avisos que se solapan con la ventana visible [desde, hasta] (para el banner
 * "arriba del calendario"). Comparación lexicográfica de fechas ISO. */
export function notasEnRango(notas: MercadoNota[], desde: string, hasta: string): MercadoNota[] {
  return notas.filter((n) => n.fechaInicio <= hasta && n.fechaFin >= desde);
}

/** Mapa díaISO → avisos que cubren ese día dentro de [desde, hasta] (para el
 * marcador por celda y el detalle del día). */
export function notasPorDia(
  notas: MercadoNota[],
  desde: string,
  hasta: string,
): Map<string, MercadoNota[]> {
  const m = new Map<string, MercadoNota[]>();
  const winStart = dayjs(desde);
  const winEndExcl = dayjs(hasta).add(1, "day");
  for (const n of notas) {
    let cur = dayjs(n.fechaInicio);
    if (cur.isBefore(winStart)) cur = winStart;
    const finExcl = dayjs(n.fechaFin).add(1, "day"); // fechaFin INCLUIDA
    const stop = finExcl.isBefore(winEndExcl) ? finExcl : winEndExcl;
    let guard = 0;
    while (cur.isBefore(stop) && guard < 400) {
      const key = cur.format("YYYY-MM-DD");
      const arr = m.get(key) ?? [];
      arr.push(n);
      m.set(key, arr);
      cur = cur.add(1, "day");
      guard += 1;
    }
  }
  return m;
}
